import { useRef } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Transition, TransitionGroup } from "react-transition-group";

import {
  EditDocument,
  LabUploadsModal,
  MedicalRecordUploadsModal,
  PrescriptionUploadsModal,
  PreviewDocument,
  RemoveDocument,
} from "@/app/components/legacy-modals";
import { MODAL_ROUTES } from "../constants";

export const ModalRouter = ({ showModal }: { showModal: boolean }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const nodeRef = useRef(null);

  return (
    <TransitionGroup>
      <Transition key={location.pathname} timeout={600} nodeRef={nodeRef}>
        {(state) => {
          const show = state !== "exited" && state !== "exiting";

          if (!showModal) {
            return null;
          }

          const goBack = () => state !== "exiting" && navigate(-1);

          return (
            <div ref={nodeRef}>
              <Routes location={location}>
                {/* Document Center Modals */}
                <Route
                  path={`${MODAL_ROUTES.DOCUMENT_CENTER.LABS}`}
                  element={<LabUploadsModal show={show} onClose={goBack} />}
                />
                <Route
                  path={`${MODAL_ROUTES.DOCUMENT_CENTER.PRESCRIPTIONS}`}
                  element={
                    <PrescriptionUploadsModal show={show} onClose={goBack} />
                  }
                />
                <Route
                  path={`${MODAL_ROUTES.DOCUMENT_CENTER.MEDICAL_RECORDS}`}
                  element={
                    <MedicalRecordUploadsModal show={show} onClose={goBack} />
                  }
                />
                <Route
                  path={`${MODAL_ROUTES.DOCUMENT_CENTER.REMOVE_DOCUMENT}/:folder/:documentId`}
                  element={<RemoveDocument show={show} onClose={goBack} />}
                />
                <Route
                  path={`${MODAL_ROUTES.DOCUMENT_CENTER.EDIT_DOCUMENT}/:folder/:documentId`}
                  element={<EditDocument show={show} onClose={goBack} />}
                />
                <Route
                  path={`${MODAL_ROUTES.DOCUMENT_CENTER.PREVIEW_DOCUMENT}/:folder/:documentId`}
                  element={<PreviewDocument show={show} onClose={goBack} />}
                />
              </Routes>
            </div>
          );
        }}
      </Transition>
    </TransitionGroup>
  );
};
